import { Entity } from "../../state/helpers/Entity"

type SessionAttributes = {
    status: string,
    data : SessionDataAttributes,
    errors : SessionErrorAttributes[] | null
}

type SessionDataAttributes = {
    session_id : string,
    session_key : string,
    //TODO
    statements : object[],
    expires_at : string
}

type SessionErrorAttributes = {
    field : string,
    code : string,
    message : string
}

export type SessionDto = {
    id : string
    attributes: SessionAttributes
}

export default class Session implements Entity {
    private dto: SessionDto

    constructor(dto: SessionDto) {
        this.dto = dto
    }
    isLoaded(): boolean {
        return this.dto.id != ""
    }

    getId(): string {
        return this.dto.id
    }

    getSessionKey(): string {
        return this.dto.attributes.data.session_key
    }

    getExpiresAt(): string {
        return this.dto.attributes.data.expires_at
    }

}


// WEBPACK FOOTER //
// ./src/payment-account/model/session.ts